module.exports = __webpack_public_path__ + "static/Quote 1 - Mobile-c3e9cf6b08655c3397329fdae1e664ac.png";